import { IotButton } from "@core/presentation/components/general/button/iot-button.component";
import { IotTypography } from "@core/presentation/components/general/typography/iot-typography.component";
import { container } from "@di/inversify.config.ts";
import { AuthenticatedUserIsLoggedUseCase } from "@iot-platform/authentication";
import { HomeRoutes } from "@routes/private/home.routes";
import { LoginRoutes } from "@routes/public/login.routes";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router";

export const MissingRoute: FC = () => {
    const { t } = useTranslation("component");
    const isUserLogged = container
        .get(AuthenticatedUserIsLoggedUseCase)
        .execute();

    const location = useLocation();
    const navigate = useNavigate();

    // In case no matched route, we redirect to the "main" route in dashboard
    // if user is logged, if not to the login
    const redirectToRoute = isUserLogged ? HomeRoutes.HOME : LoginRoutes.LOGIN;

    const handleGoBackHome = (): void => {
        void navigate(redirectToRoute);
    };

    console.error(`unmatched url: ${location.pathname}`);

    return location.pathname === "/" ? (
        <Navigate
            to={redirectToRoute}
            replace
        />
    ) : (
        <div
            className={
                "tw:grid tw:h-[100vh] tw:place-content-center tw:bg-white tw:px-4"
            }
        >
            <div className={"tw:text-center"}>
                <IotTypography.Title
                    level={1}
                    className={"tw:text-9xl tw:font-black tw:text-gray-200"}
                >
                    404
                </IotTypography.Title>

                <IotTypography.Paragraph
                    className={
                        "tw:text-2xl tw:font-bold tw:tracking-tight tw:text-gray-900 tw:sm:text-4xl"
                    }
                >
                    {t("missingRoute.title")}
                </IotTypography.Paragraph>

                <IotTypography.Paragraph className={"tw:mt-4 tw:text-gray-500"}>
                    {t("missingRoute.description")}
                </IotTypography.Paragraph>
                <IotButton
                    className={"tw:mt-6"}
                    type={"primary"}
                    onClick={handleGoBackHome}
                >
                    {t("missingRoute.goBackHome")}
                </IotButton>
            </div>
        </div>
    );
};
